import moment from 'moment';

/**
 * Shared contract-estado derivation. Contract state always outranks payment
 * state: a finalizado or vencido contract shows as such even if it also has
 * overdue/pending cobros. `cobrosPendientes`/`cobrosVencidos` are per-row
 * counts of unpaid generated dues, added by the /contracts/search aggregate.
 */
export function contractEstado(contract) {
	if (contract.closeDate || contract.status === 'closed') {
		return 'finalizado';
	}
	if (contract.periodEnd && moment.utc(contract.periodEnd).isBefore(moment.utc())) {
		return 'vencido';
	}
	if ((contract.cobrosVencidos || 0) > 0) {
		return 'cobroVencido';
	}
	if ((contract.cobrosPendientes || 0) > 0) {
		return 'cobroPendiente';
	}
	return 'vigente';
}

export const CONTRACT_ESTADO_TONE = {
	finalizado: 'neutral',
	vencido: 'danger',
	cobroVencido: 'danger',
	cobroPendiente: 'warn',
	vigente: 'ok',
};

export const CONTRACT_ESTADO_LABEL = {
	finalizado: 'Finalizado',
	vencido: 'Vencido',
	cobroVencido: 'Cobro vencido',
	cobroPendiente: 'Cobro pendiente',
	vigente: 'Vigente',
};
